<template>
  <v-container class="grey lighten-5">

     <v-dialog
      v-model="personModal"
      scrollable
      persistent
      width="650">
      <personDetailForm
        :uid='uid'
        :data='familyHistoryArr'
        v-on:closePersonModal="personModalClose"
        :indexNum='personIndex'/>
    </v-dialog>


    

    <!-- Stack the columns on mobile by making one full-width and the other half-width -->
    <v-row>
      <v-col v-for='(member,index) in familyHistoryArr' :key='index'
        cols="6"
        md="4"
      >
      
  <v-card>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title @click='personModal = true;personIndex = index' style='text-decoration : underline; cursor: pointer;' class="headline">{{member.name}}</v-list-item-title>
        <v-list-item-subtitle>Age: {{calculateAge(member.dob)}}</v-list-item-subtitle>
        <v-list-item-subtitle>{{member.relationship}}</v-list-item-subtitle>
         <v-list-item-subtitle>{{member.gender}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-text>
      <p v-if='member.parents'>parents : {{member.parents}}</p>
      Conditions: 
    <v-simple-table v-if='member.conditions.length > 0' dense>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">Name</th>
          <th class="text-left">Type</th>
          <th class="text-left">Dx Age</th>   
          <th class="text-left">Detail</th>
         </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in member.conditions" :key="index">
          <td>{{ item.name }}</td>
          <td>{{ item.type }}</td>
          <td>{{ item.age }}</td>
          <td>{{ item.detail }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  <p v-else>No condition/user did not provide any infomation</p>
    </v-card-text>
  </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import personDetailForm from "../components/editPerson/editPersonForm"
export default {
  components : {
    personDetailForm
  },
  data(){
    return{
      personModal : false,
      personIndex : null,
    }
  },
    props : {
        uid : String,
        familyHistoryArr : Array,
    },
    methods : {
          personModalClose(){
      this.personModal = false
    },
              calculateAge(dob){
			if(!dob){
				return 0
			}
          let age = this.$moment().diff(this.$moment(dob, 'YYYYMMDD'), 'years')
            return age;
        },
    }
}
</script>